import React from "react";
import * as DateHelper from "../../utils/date.formatter";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

export default props => {
  if (!props.data || props.data.length === 0) {
    return <></>;
  }
  let formarted_data = [];
  props.data.reduce((pre, cur) => {
    formarted_data.push({
      time: DateHelper.toLocalString(cur.created),
      temp: cur.value
    });
    return formarted_data;
  }, []);

  return (
    <div className="graph-box">
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={formarted_data}>
          <CartesianGrid strokeDasharray="5 5" />
          <XAxis dataKey="time" />
          <YAxis
            type="number"
            domain={[35, 40]}
            width={30}
            minTickGap={0.5}
            interval={0}
          />
          <Tooltip />
          <Line
            type="linear"
            dataKey="temp"
            stroke="#FA6C39"
            strokeWidth={2}
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
